import { render } from "./ChatbotServicePage.vue?vue&type=template&id=20278e97&scoped=true"
import script from "./ChatbotServicePage.vue?vue&type=script&lang=js"
export * from "./ChatbotServicePage.vue?vue&type=script&lang=js"

import "./ChatbotServicePage.vue?vue&type=style&index=0&id=20278e97&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20278e97"]])

export default __exports__